if (!customElements.get('category-showcase')) {
  class CategoryShowcase extends HTMLElement {
    constructor() {
      super();
      this.sectionId = this.dataset.sectionId;
      this.swiper = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    initSwiper() {
      const swiperEl = this.querySelector('.swiper');
      if (!swiperEl) return;

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        effect: 'fade',
        fadeEffect: {
          crossFade: true
        },
        speed: 500,
        on: {
          slideChange: () => {
            this.updateCounter();
            this.updateArrowStates();
          }
        }
      });

      this.bindNavigation();
      this.updateCounter();
      this.updateArrowStates();
    }

    bindNavigation() {
      const prevBtns = this.querySelectorAll('.category-showcase__arrow--prev');
      const nextBtns = this.querySelectorAll('.category-showcase__arrow--next');

      prevBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.swiper && !this.swiper.isBeginning) this.swiper.slidePrev();
        });
      });

      nextBtns.forEach(btn => {
        btn.addEventListener('click', () => {
          if (this.swiper && !this.swiper.isEnd) this.swiper.slideNext();
        });
      });
    }

    updateCounter() {
      if (!this.swiper) return;

      const counters = this.querySelectorAll('.category-showcase__current');
      const realIndex = this.swiper.realIndex + 1;

      counters.forEach(counter => {
        counter.textContent = realIndex;
      });
    }

    updateArrowStates() {
      if (!this.swiper) return;

      const prevBtns = this.querySelectorAll('.category-showcase__arrow--prev');
      const nextBtns = this.querySelectorAll('.category-showcase__arrow--next');

      prevBtns.forEach(btn => {
        btn.classList.toggle('is-disabled', this.swiper.isBeginning);
      });

      nextBtns.forEach(btn => {
        btn.classList.toggle('is-disabled', this.swiper.isEnd);
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
        this.swiper = null;
      }
    }
  }

  customElements.define('category-showcase', CategoryShowcase);
}
